import { useContainer } from '../../../hooks/useContainer';
import { AuthApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

export interface SignUpValues {
    email: string;
    password: string;
    givenName: string;
    familyName: string;
}

const useHttpPostSignUp = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (values: SignUpValues, callback: ICallback) => {
        const { exec, abort } = authApi.signUp({
            body: {
                email: values.email,
                password: values.password,
                givenName: values.givenName,
                familyName: values.familyName,
            },
            onSuccess: () => {
                toastHandler.push('success', t('auth.signUpTitle'), t('auth.signUpMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: error => {
                if (error.includes('already exists!')) {
                    toastHandler.push('error', t('auth.signUpFailedTitle'), t('auth.signUpFailedMessage_FailedAlreadyExist'));
                    navigate(`/sign-in`);
                } else {
                    toastHandler.push('error', t('auth.signUpFailedTitle'), error);
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostSignUp;
